import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './PackageSort.scss';

export const SortListItem = ({selected, sortColumn, sortDirection, text, onClickAction}) => {
    const clickAction = () => onClickAction({sortColumn, sortDirection});
    return (
        <li key={sortColumn + sortDirection} className={styles.listItem}>
            <a className={
                classNames(
                    styles.option,
                    {
                        [styles.selected]: selected,
                        [styles['initial-selected']]: selected,
                        [styles['option--ascending']]: sortDirection === 'ascending',
                        [styles['option--descending']]: sortDirection === 'descending',
                    }
                )
            }
                onClick={clickAction}>{text}</a>
        </li>
    );
};

SortListItem.propTypes = {
    selected: PropTypes.bool,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    text: PropTypes.string,
    onClickAction: PropTypes.func,
};

export const createOnClickCallback = (sortOptions, sortHandler) => (nextState) => {
    const reverse = direction => direction === 'ascending' ? 'descending' : 'ascending';
    const newSortOptions = sortOptions.map(option => ({
        ...option,
        sortDirection: option.sortColumn === nextState.sortColumn ?
            reverse(option.sortDirection) : option.sortColumn,
        selected: option.sortColumn === nextState.sortColumn,
    }));

    sortHandler(newSortOptions);
};

export const PackageSort = ({sortOptions, sortHandler}) => {
    const listItems = sortOptions.map(
        (item) => (<SortListItem
            key={item.sortColumn + item.sortDirection}
            onClickAction={createOnClickCallback(sortOptions, sortHandler)}
            {...item}
        />)
    );
    return (
        <div className={styles.PackageSort}>
            <span className={styles.title}>SORT:</span>
            <ul id="sda-sort-list" className={styles.list}>{listItems}</ul>
        </div>
    );
};

PackageSort.propTypes = {
    sortOptions: PropTypes.array,
    sortHandler: PropTypes.func,
};

export default PackageSort;
